import videojs from 'video.js';
import './nextBtn/';
import './changeResolutionBtn/';

const VideoComponent = videojs.getComponent('Component');

/**
 * 控制条左侧按钮栏
 */
class ControlBarBtnsLeft extends VideoComponent {
    constructor(player, options) {
        super(player, options);
        this.initChildrens(this.player().options_);
    }

    initChildrens(opts) {
        const {
            controlBar: {
                playToggle = true,
                nextVideoPanel = true,
                currentTimeDisplay = true,
                timeDivider = true,
                durationDisplay = true,
            },
            nextVideoInfo,
        } = opts;

        if (playToggle) {
            this.addChild('PlayToggle');
        }

        if (nextVideoPanel && nextVideoInfo) {
            this.addChild('NextVideoPanel', { nextVideoInfo });
        }

        if (currentTimeDisplay) {
            this.addChild('CurrentTimeDisplay');
        }

        if (timeDivider && durationDisplay) {
            this.addChild('TimeDivider');
            this.addChild('DurationDisplay');
        }
    }

    createEl() {
        const btnsLeft = super.createEl('div', {
            className: 'videoBtnsLeft',
        });

        return btnsLeft;
    }
}

videojs.registerComponent('ControlBarBtnsLeft', ControlBarBtnsLeft);

/**
 * 控制条右侧按钮栏
 */
class ControlBarBtnsRight extends VideoComponent {
    constructor(player, options) {
        super(player, options);
        this.initChildrens(this.player_.options_);
    }

    initChildrens(opts) {
        const {
            controlBar: { volumePanel = true, changeResPanel = true, fullscreenToggle = true },
            bqSrc,
            gqSrc,
        } = opts;

        if (fullscreenToggle) {
            this.addChild('FullscreenToggle');
        }
        if (changeResPanel && bqSrc && gqSrc) {
            this.addChild('ChangeResPanel');
        }
        if (volumePanel) {
            this.addChild('VolumePanel');
        }
    }

    createEl() {
        const btnsRight = super.createEl('div', {
            className: 'videoBtnsRight',
        });

        return btnsRight;
    }
}

videojs.registerComponent('ControlBarBtnsRight', ControlBarBtnsRight);

/**
 * 自定义控制条按钮栏
 */
class FengControlBarVideoBtns extends VideoComponent {
    createEl() {
        const controlContainer = super.createEl('div', {
            className: 'feng-controlBar-btns',
        });

        return controlContainer;
    }
}

FengControlBarVideoBtns.prototype.options_ = {
    children: ['ControlBarBtnsLeft', 'ControlBarBtnsRight'],
};

videojs.registerComponent('FengControlBarVideoBtns', FengControlBarVideoBtns);
